import { createSelector } from 'reselect';
import {
  LAUNCHDARKLY_ANONYMOUS,
  LAUNCHDARKLY_IDENTIFY
} from '../store/middleware/launchdarkly';
import { session as sessionSelector } from './session';
import { createPropertySelector } from './helpers';
import { camelCase } from 'change-case';

export const identify = createSelector(sessionSelector, session => {
  if (!session) return null;
  const { userID: key, experience, username, teamName } = session;
  return {
    type: LAUNCHDARKLY_IDENTIFY,
    payload: {
      key,
      anonymous: false,
      custom: {
        experience,
        teamName,
        username
      }
    }
  };
});

export const reset = createSelector(
  sessionSelector,
  session =>
    session
      ? null
      : {
          type: LAUNCHDARKLY_IDENTIFY,
          payload: LAUNCHDARKLY_ANONYMOUS
        }
);

export const feature = ({ feature = {} } = {}) => feature;

export const createFeatureSelector = name =>
  createSelector(createPropertySelector(feature, camelCase(name)), value => {
    return typeof value === 'object' && value !== null ? value.current : value;
  });

export const adHocEnabled = createFeatureSelector('ad-hoc-tasks');
export const aiModelEnabled = createFeatureSelector('ai-model');
export const categoryFilterEnabled = createFeatureSelector('category-filter');
export const dataTableFieldEnabled = createFeatureSelector('data-table-field');
export const editPushbotEnabled = createFeatureSelector('edit-pushbot');
export const embeddedModeEnabled = createFeatureSelector(
  'pushbot-web-embedded'
);
export const formInstructionsEnabled = createFeatureSelector(
  'form-instructions'
);
export const friendlyFieldsEnabled = createFeatureSelector('friendly-fields');
export const FRONT_END_PERFORMANCE_MONITORING =
  'front-end-performance-monitoring';
export const frontEndPerformanceMonitoringEnabled = createFeatureSelector(
  FRONT_END_PERFORMANCE_MONITORING
);
export const includeDraftApps = createFeatureSelector('draft-apps');
export const passwordComplexityEnabled = createFeatureSelector(
  'password-complexity'
);
export const manualReportingEnabled = createFeatureSelector('manual-reporting');
export const pushbotCommentEnabled = createFeatureSelector('pushbot-comment');
export const runDetailV2Enabled = createFeatureSelector('run-detail-v2');
export const runPermissionsEnabled = createFeatureSelector('run-permissions');
export const splitPaneEnabled = createFeatureSelector('split-pane');
export const tablePermissionsEnabled = createFeatureSelector(
  'data-table-permissions'
);
export const tasksQueryEnabled = createFeatureSelector('tasks-query');
export const timelineChartEnabled = createFeatureSelector('timeline-chart');
export const urlParametersEnabled = createFeatureSelector('url-parameters');
export const watchListEnabled = createFeatureSelector('watch-list');
export const webformsV2Enabled = createFeatureSelector('webforms-v-2');
export const workDoneBetterNavigationEnabled = createFeatureSelector(
  'work-done-better-navigation'
);



// WEBPACK FOOTER //
// ./js/selectors/feature.js